// users.effects.ts
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';
import { UsersService } from 'app/core/service/users.service';
import {
    GetUsers,
    GetUsersSuccess,
    GetUsersError,
    GetSingleUser,
    GetSingleUserSuccess,
    GetSingleUserError,
    PostUser,
    PostUserSuccess,
    PostUserError,
    EditUser,
    EditUserSuccess,
    EditUserError,
    DeleteUser,
    DeleteUserSuccess,
    DeleteUserError,
    SyncUsers,
    SyncUsersSuccess,
    SyncUsersError
} from '../actions/users.actions';
import { UsersAction } from '../constants';

@Injectable()
export class UsersEffects {
    getUsers$ = createEffect(() =>
        this.actions$.pipe(
            ofType<GetUsers>(UsersAction.GetUsers),
            switchMap(() =>
                this.usersService.getUsers().pipe(
                    mergeMap((response: any) => {
                        const users = response.results || response; // Manejamos ambos casos
                        return of(new GetUsersSuccess(users));
                    }),
                    catchError((error) => {
                        return of(new GetUsersError());
                    }),
                )
            ),
        ),
    );

    getSingleUser$ = createEffect(() =>
        this.actions$.pipe(
            ofType<GetSingleUser>(UsersAction.GetSingleUser),
            switchMap((action) =>
                this.usersService.getSingleUser(action.userId).pipe(
                    mergeMap((user: any) => {
                        return of(new GetSingleUserSuccess(user));
                    }),
                    catchError((error) => {
                        return of(new GetSingleUserError());
                    }),
                )
            ),
        ),
    );

    postUser$ = createEffect(() =>
        this.actions$.pipe(
            ofType<PostUser>(UsersAction.PostUser),
            switchMap((action) =>
                this.usersService.postUser(action.data).pipe(
                    mergeMap((user: any) => {
                        return of(new PostUserSuccess(user));
                    }),
                    catchError((error) => {
                        return of(new PostUserError());
                    }),
                )
            ),
        ),
    );

    editUser$ = createEffect(() =>
        this.actions$.pipe(
            ofType<EditUser>(UsersAction.EditUser),
            switchMap((action) =>
                this.usersService.editUser(action.data).pipe(
                    mergeMap((user: any) => {
                        return of(new EditUserSuccess(user));
                    }),
                    catchError((error) => {
                        return of(new EditUserError());
                    }),
                )
            ),
        ),
    );

    deleteUser$ = createEffect(() =>
        this.actions$.pipe(
            ofType<DeleteUser>(UsersAction.DeleteUser),
            switchMap((action) =>
                this.usersService.deleteUser(action.userId).pipe(
                    mergeMap(() => {
                        return of(new DeleteUserSuccess(action.userId));
                    }),
                    catchError((error) => {
                        return of(new DeleteUserError());
                    }),
                )
            ),
        ),
    );

    syncUsers$ = createEffect(() =>
        this.actions$.pipe(
            ofType<SyncUsers>(UsersAction.SyncUsers),
            switchMap(() =>
                this.usersService.sync().pipe(
                    mergeMap((response: any) => {
                        const users = response.results || response;
                        return of(new SyncUsersSuccess(users));
                    }),
                    catchError((error) => {
                        return of(new SyncUsersError());
                    }),
                )
            ),
        ),
    );

    constructor(
        private usersService: UsersService,
        private actions$: Actions,
    ) { }
}